<div class="h-full flex flex-col justify-start items-center overflow-hidden">
    <form
        class="mx-auto h-full flex flex-col justify-start items-center overflow-y-auto scrollbar-transparent w-full divide-y divide-zinc-200 dark:divide-zinc-800">
        <div class="space-y-12 w-full">
            <!-- Has Rakuten Bolt On -->
            <div *hasBoltOn="[environment.stripe.shaas21products.bo_affiliates_rakuten]"
                class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-zinc-500/10 dark:border-zinc-800 pb-12 md:grid-cols-3">
                <div>
                    <h2 class="text-base/7 font-semibold text-primary">Rakuten Affiliate Marketing</h2>
                    <p class="mt-1 text-sm/6 text-gray-400">Connect your Rakuten affiliate account to enable affiliate
                        marketing for your brand.</p>
                </div>

                <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">

                    <div class="sm:col-span-4">
                        <label for="rakuten-advertiser-id" class="block text-sm/6 font-medium text-primary">Rakuten
                            Advertiser ID</label>
                        <div class="mt-2">
                            <input [formField]="rakutenAdvertiserIdForm.rakutenAdvertiserId" id="rakuten-advertiser-id"
                                type="text" placeholder="Enter your Rakuten Advertiser ID" autocomplete="given-name"
                                class="input-primary text-primary" />
                        </div>
                        <p class="mt-1 text-xs leading-6 text-gray-600">From your Rakuten Advertising account</p>
                    </div>
                </div>
            </div>
            <!-- Has Rakuten Bolt On - END -->

            <!--NOT Has Rakuten Bolt On -->
            <div *notHasBoltOn="[environment.stripe.shaas21products.bo_affiliates_rakuten]"
                class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-zinc-500/10 dark:border-zinc-800 pb-12 md:grid-cols-3">
                <div>
                    <h2 class="text-base/7 font-semibold text-primary">Rakuten Affiliate Marketing</h2>
                    <p class="mt-1 text-sm/6 text-gray-400">Add the Bolt-On to enable Rakuten Affiliate Marketing.</p>
                </div>

                <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                    <div class="col-span-full py-1 pr-2">

                        <div
                            class="mx-auto max-w-2xl rounded-3xl ring-1 ring-gray-200 lg:mx-0 lg:flex lg:max-w-none dark:bg-gray-800/50 dark:ring-white/10">
                            <div class="p-2 sm:p-4 lg:flex-auto">
                                <div class="flex flex-row items-start justify-start gap-x-4">
                                    <div
                                        class="size-10 rounded-lg border border-zinc-200 dark:border-zinc-800 bg-zinc-50 dark:bg-zinc-800/60 p-2 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="72.97" height="77.64"
                                            viewBox="0 0 72.97 77.64" class="size-6">
                                            <g id="rakuten-edy-logo" transform="translate(-3.99)">
                                                <path id="Path_12" data-name="Path 12"
                                                    d="M14.4,77.64,3.99,68.91H76.96ZM26.25,62.36V43h8.38L49.14,62.36H64L46.44,39A21.49,21.49,0,0,0,34,0H14.4V62.36Zm0-50.52H34a9.67,9.67,0,1,1,0,19.33H26.25Z"
                                                    fill="#bf0000" />
                                            </g>
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 class="text-basefont-semibold text-primary">
                                            Rakuten Affiliate Marketing</h3>
                                        <p class="mt-1 text-xs text-secondary">Run SHOUT campaigns
                                            for your
                                            existing Rakuten Advertiser account.</p>
                                    </div>
                                </div>

                                <div class="mt-4 flex items-center gap-x-4">
                                    <h4 class="flex-none text-sm/6 font-semibold text-accent">
                                        What’s included</h4>
                                    <div class="h-px flex-auto bg-gray-100 dark:bg-white/10"></div>
                                </div>
                                <ul role="list"
                                    class="mt-2 grid grid-cols-1 gap-4 text-sm/6 text-gray-600 sm:grid-cols-2 sm:gap-4 dark:text-gray-300">
                                    @for (detail of rakutenModeDetails; track detail) {
                                    <li class="flex gap-x-3 text-xs items-center">
                                        <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                            class="size-4 flex-none text-accent">
                                            <path
                                                d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                clip-rule="evenodd" fill-rule="evenodd" />
                                        </svg>
                                        {{ detail }}
                                    </li>
                                    }
                                </ul>
                            </div>
                            <div class="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:shrink-0">
                                <div
                                    class="rounded-2xl bg-gray-50 py-10 text-center inset-ring inset-ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-16 dark:bg-gray-900 dark:inset-ring-white/10">
                                    <div class="mx-auto max-w-xs px-8">
                                        <p class="text-base font-semibold text-gray-600 dark:text-gray-400">Add the
                                            Bolt-On</p>
                                        <p class="mt-6 flex items-baseline justify-center gap-x-2">
                                            <span
                                                class="text-5xl font-semibold text-gray-900 dark:text-white">£999</span>
                                            <span
                                                class="text-sm/6 font-semibold tracking-wide text-gray-600 dark:text-gray-400">GBP</span>
                                            <span
                                                class="text-sm/6 font-normal tracking-wide text-gray-600 dark:text-gray-400">/month</span>
                                        </p>
                                        <a
                                            class="mt-10 block w-full rounded-md bg-primary px-3 py-2 text-center text-sm font-semibold text-white shadow-xs hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:shadow-none dark:hover:bg-primary/90 dark:focus-visible:outline-primary">Upgrade
                                            now</a>
                                        <p class="mt-6 text-xs/5 text-gray-600 dark:text-gray-400">Invoices and receipts
                                            available for easy company reimbursement</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <!--NOT Has Rakuten Bolt On - END -->

            @if (rakutenAdvertiser()) {
            <div
                class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-zinc-500/10 dark:border-zinc-800 pb-12 md:grid-cols-3">
                <div>
                    <h2 class="text-base/7 font-semibold text-primary">Rakuten Advertiser</h2>
                    <p class="mt-1 text-sm/6 text-gray-400">We've found your Rakuten Advertiser account.</p>
                </div>

                <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">

                    <div class="sm:col-span-3">
                        <label for="rakuten-advertiser-id" class="block text-sm/6 font-medium text-primary">Advertiser
                            Name</label>
                        <div class="mt-2">
                            <input [formField]="foundAdvertiserForm.name" id="rakuten-advertiser-id" type="text"
                                placeholder="Enter your Rakuten Advertiser ID" autocomplete="given-name"
                                class="input-primary text-primary disabled:bg-white/10 disabled:text-primary/50 disabled:cursor-not-allowed" />
                        </div>
                    </div>

                    <div class="sm:col-span-3">
                        <label for="company-website" class="block text-sm/6 font-medium text-primary">Advertiser
                            URL</label>
                        <div class="mt-2 flex">
                            <div
                                class="flex shrink-0 items-center rounded-l-md bg-white/50 dark:bg-white/5 px-3 text-base text-gray-400 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-gray-700 sm:text-sm/6 disabled:bg-white/10 disabled:text-primary/50 dark:disabled:text-white/50 disabled:cursor-not-allowed">
                                https://</div>
                            <input [formField]="foundAdvertiserForm.url" id="company-website" type="text"
                                placeholder="www.example.com"
                                class="-ml-px block w-full grow rounded-r-md bg-white/50 dark:bg-white/5 px-3 py-1.5 text-base text-primary outline-1 -outline-offset-1 outline-zinc-300 dark:outline-gray-700 placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 disabled:bg-white/10 disabled:text-primary/50 dark:disabled:text-white/50 disabled:cursor-not-allowed" />
                        </div>
                    </div>

                    <div
                        class="sm:col-span-3 flex flex-row items-center justify-between rounded-md bg-white/50 dark:bg-white/5 px-3 py-1.5 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-gray-700">
                        <label for="company-website" class="block text-sm/6 font-medium text-primary">Can
                            Partner?</label>
                        <div>
                            @if (rakutenAdvertiser()?.advertiser?.can_partner) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-green-500">
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            } @else {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-red-500">
                                <path d="M18 6 6 18" />
                                <path d="m6 6 12 12" />
                            </svg>
                            }
                        </div>
                    </div>

                    <div
                        class="sm:col-span-3 flex flex-row items-center justify-between rounded-md bg-white/50 dark:bg-white/5 px-3 py-1.5 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-gray-700">
                        <label for="company-website" class="block text-sm/6 font-medium text-primary">Deep Links</label>
                        <div>
                            @if (rakutenAdvertiser()?.advertiser?.features?.deep_links) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-green-500">
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            } @else {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-red-500">
                                <path d="M18 6 6 18" />
                                <path d="m6 6 12 12" />
                            </svg>
                            }
                        </div>
                    </div>

                    <div
                        class="sm:col-span-3 flex flex-row items-center justify-between rounded-md bg-white/50 dark:bg-white/5 px-3 py-1.5 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-gray-700">
                        <label for="company-website" class="block text-sm/6 font-medium text-primary">ITP
                            Compliant</label>
                        <div>
                            @if (rakutenAdvertiser()?.advertiser?.features?.itp_compliant) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-green-500">
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            } @else {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-red-500">
                                <path d="M18 6 6 18" />
                                <path d="m6 6 12 12" />
                            </svg>
                            }
                        </div>
                    </div>

                    <div
                        class="sm:col-span-3 flex flex-row items-center justify-between rounded-md bg-white/50 dark:bg-white/5 px-3 py-1.5 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-gray-700">
                        <label for="company-website" class="block text-sm/6 font-medium text-primary">Media Opt
                            Report</label>
                        <div>
                            @if (rakutenAdvertiser()?.advertiser?.features?.media_opt_report) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-green-500">
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            } @else {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-red-500">
                                <path d="M18 6 6 18" />
                                <path d="m6 6 12 12" />
                            </svg>
                            }
                        </div>
                    </div>

                    <div
                        class="sm:col-span-3 flex flex-row items-center justify-between rounded-md bg-white/50 dark:bg-white/5 px-3 py-1.5 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-gray-700">
                        <label for="company-website" class="block text-sm/6 font-medium text-primary">Premium
                            Advertiser</label>
                        <div>
                            @if (rakutenAdvertiser()?.advertiser?.features?.premium_advertiser) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-green-500">
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            } @else {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-red-500">
                                <path d="M18 6 6 18" />
                                <path d="m6 6 12 12" />
                            </svg>
                            }
                        </div>
                    </div>

                    <div
                        class="sm:col-span-3 flex flex-row items-center justify-between rounded-md bg-white/50 dark:bg-white/5 px-3 py-1.5 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-gray-700">
                        <label for="company-website" class="block text-sm/6 font-medium text-primary">Product
                            Feed</label>
                        <div>
                            @if (rakutenAdvertiser()?.advertiser?.features?.product_feed) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-green-500">
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            } @else {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-red-500">
                                <path d="M18 6 6 18" />
                                <path d="m6 6 12 12" />
                            </svg>
                            }
                        </div>
                    </div>

                </div>
            </div>



            <div
                class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-zinc-500/10 dark:border-zinc-800 pb-12 md:grid-cols-3">
                <div>
                    <h2 class="text-base/7 font-semibold text-primary">Rakuten Partnership</h2>
                    <p class="mt-1 text-sm/6 text-gray-400">Here are the details of the Affiliate Marketing Partnership
                        between your brand, Rakuten & SHOUT.</p>
                </div>

                <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">

                    @if (partnershipError()) {
                    <div
                        class="rounded-md bg-yellow-50 dark:bg-yellow-500/10 p-4 outline outline-yellow-200 dark:outline-yellow-500/15 col-span-full">
                        <div class="flex">
                            <div class="shrink-0">
                                <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                    class="size-5 text-yellow-600 dark:text-yellow-300">
                                    <path
                                        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                                        clip-rule="evenodd" fill-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="ml-3">
                                <h3 class="text-sm font-medium text-yellow-800 dark:text-yellow-100">Partnership not
                                    found</h3>
                                <div class="mt-2 text-sm text-yellow-700 dark:text-yellow-100/80">
                                    <p>We couldn't find the Rakuten Partnership between your brand, Rakuten & SHOUT.
                                        Please contact support to get this resolved.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    } @else {
                    @if (foundPartnership()) {
                    <div
                        class="sm:col-span-3 flex flex-row items-center justify-between rounded-md bg-white/50 dark:bg-white/5 px-3 py-1.5 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-gray-700">
                        <label for="company-website" class="block text-sm/6 font-medium text-primary">Status</label>
                        <span
                            class="inline-flex items-center rounded-full bg-green-50 dark:bg-green-400/10 px-2 py-1 text-xs font-medium text-green-700 dark:text-green-400 inset-ring inset-ring-green-500/20">{{foundPartnership()?.partnership?.status}}</span>
                    </div>

                    <div
                        class="sm:col-span-3 flex flex-row items-center justify-between rounded-md bg-white/50 dark:bg-white/5 px-3 py-1.5 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-gray-700">
                        <label for="company-website" class="block text-sm/6 font-medium text-primary">Status
                            Updated</label>
                        <p class="text-sm/6 text-primary">{{foundPartnership()?.partnership?.status_update_datetime |
                            date:'dd/MM/yyyy HH:mm'}}</p>
                    </div>

                    <div
                        class="sm:col-span-3 flex flex-row items-center justify-between rounded-md bg-white/50 dark:bg-white/5 px-3 py-1.5 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-gray-700">
                        <label for="company-website" class="block text-sm/6 font-medium text-primary">Approved
                            Date</label>
                        <p class="text-sm/6 text-primary">{{foundPartnership()?.partnership?.approve_datetime |
                            date:'dd/MM/yyyy HH:mm'}}</p>
                    </div>

                    <div
                        class="sm:col-span-3 flex flex-row items-center justify-between rounded-md bg-white/50 dark:bg-white/5 px-3 py-1.5 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-gray-700">
                        <label for="company-website" class="block text-sm/6 font-medium text-primary">Applied
                            Date</label>
                        <p class="text-sm/6 text-primary">{{foundPartnership()?.partnership?.apply_datetime |
                            date:'dd/MM/yyyy HH:mm'}}</p>
                    </div>
                    }
                    }


                </div>
            </div>
            }


            <!-- ------------------------------------------------------------ -->
            <!-- ------------------------------------------------------------ -->
            <!-- ------------------------------------------------------------ -->







            <!-- Has Shopify Bolt On -->
            <div *hasBoltOn="[environment.stripe.shaas21products.bo_affiliates_shopify]"
                class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-zinc-500/10 dark:border-zinc-800 pb-12 md:grid-cols-3">
                <div>
                    <h2 class="text-base/7 font-semibold text-primary">Affiliates Shopify</h2>
                    <p class="mt-1 text-sm/6 text-gray-400">Add the Bolt-On to enable Shopify Affiliate Marketing.</p>
                </div>

                <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">

                    <div class="sm:col-span-4">
                        <label for="shopify-api-key" class="block text-sm/6 font-medium text-primary">Shopify
                            Advertiser ID</label>
                        <div class="mt-2">
                            <input [formField]="rakutenAdvertiserIdForm.rakutenAdvertiserId" id="rakuten-advertiser-id"
                                type="text" placeholder="Enter your Rakuten Advertiser ID" autocomplete="given-name"
                                class="input-primary text-primary" />
                        </div>
                        <p class="mt-1 text-xs leading-6 text-gray-600">From your Rakuten Advertising account</p>
                    </div>
                </div>
            </div>
            <!-- Has Rakuten Bolt On - END -->

            <!--NOT Has Rakuten Bolt On -->
            <div *notHasBoltOn="[environment.stripe.shaas21products.bo_affiliates_rakuten]"
                class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-zinc-500/10 dark:border-zinc-800 pb-12 md:grid-cols-3">
                <div>
                    <h2 class="text-base/7 font-semibold text-primary">Shopify Affiliate Marketing</h2>
                    <p class="mt-1 text-sm/6 text-gray-400">Add the Bolt-On to enable Shopify Affiliate Marketing.</p>
                </div>

                <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                    <div class="col-span-full py-1 pr-2">

                        <div
                            class="mx-auto max-w-2xl rounded-3xl ring-1 ring-gray-200 lg:mx-0 lg:flex lg:max-w-none dark:bg-gray-800/50 dark:ring-white/10">
                            <div class="p-2 sm:p-4 lg:flex-auto">
                                <div class="flex flex-row items-start justify-start gap-x-4">
                                    <div
                                        class="size-10 rounded-lg border border-zinc-200 dark:border-zinc-800 bg-zinc-50 dark:bg-zinc-800/60 p-2 flex items-center justify-center">
                                        <svg width="2192" height="2500" viewBox="0 0 256 292"
                                            xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid"
                                            class="size-6">
                                            <path
                                                d="M223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-1.703-1.703-5.029-1.185-6.32-.805-.19.056-3.388 1.043-8.678 2.68-5.18-14.906-14.322-28.604-30.405-28.604-.444 0-.901.018-1.358.044C129.31 3.407 123.644.779 118.75.779c-37.465 0-55.364 46.835-60.976 70.635-14.558 4.511-24.9 7.718-26.221 8.133-8.126 2.549-8.383 2.805-9.45 10.462C21.3 95.806.038 260.235.038 260.235l165.678 31.042 89.77-19.42S223.973 58.8 223.775 57.34zM156.49 40.848l-14.019 4.339c.005-.988.01-1.96.01-3.023 0-9.264-1.286-16.723-3.349-22.636 8.287 1.04 13.806 10.469 17.358 21.32zm-27.638-19.483c2.304 5.773 3.802 14.058 3.802 25.238 0 .572-.005 1.095-.01 1.624-9.117 2.824-19.024 5.89-28.953 8.966 5.575-21.516 16.025-31.908 25.161-35.828zm-11.131-10.537c1.617 0 3.246.549 4.805 1.622-12.007 5.65-24.877 19.88-30.312 48.297l-22.886 7.088C75.694 46.16 90.81 10.828 117.72 10.828z"
                                                fill="#95BF46" />
                                            <path
                                                d="M221.237 54.983c-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-.637-.634-1.496-.959-2.394-1.099l-12.527 256.233 89.762-19.418S223.972 58.8 223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357"
                                                fill="#5E8E3E" />
                                            <path
                                                d="M135.242 104.585l-11.069 32.926s-9.698-5.176-21.586-5.176c-17.428 0-18.305 10.937-18.305 13.693 0 15.038 39.2 20.8 39.2 56.024 0 27.713-17.577 45.558-41.277 45.558-28.44 0-42.984-17.7-42.984-17.7l7.615-25.16s14.95 12.835 27.565 12.835c8.243 0 11.596-6.49 11.596-11.232 0-19.616-32.16-20.491-32.16-52.724 0-27.129 19.472-53.382 58.778-53.382 15.145 0 22.627 4.338 22.627 4.338"
                                                fill="#FFF" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 class="text-basefont-semibold text-primary">
                                            Shopify Affiliate Marketing</h3>
                                        <p class="mt-1 text-xs text-secondary">Run SHOUT campaigns
                                            for your
                                            existing Shopify Store.</p>
                                    </div>
                                </div>

                                <div class="mt-4 flex items-center gap-x-4">
                                    <h4 class="flex-none text-sm/6 font-semibold text-accent">
                                        What’s included</h4>
                                    <div class="h-px flex-auto bg-gray-100 dark:bg-white/10"></div>
                                </div>
                                <ul role="list"
                                    class="mt-2 grid grid-cols-1 gap-4 text-sm/6 text-gray-600 sm:grid-cols-2 sm:gap-4 dark:text-gray-300">
                                    @for (detail of shopifyModeDetails; track detail) {
                                    <li class="flex gap-x-3 text-xs items-center">
                                        <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                            class="size-4 flex-none text-accent">
                                            <path
                                                d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                clip-rule="evenodd" fill-rule="evenodd" />
                                        </svg>
                                        {{ detail }}
                                    </li>
                                    }
                                </ul>
                            </div>
                            <div class="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:shrink-0">
                                <div
                                    class="rounded-2xl bg-gray-50 py-10 text-center inset-ring inset-ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-16 dark:bg-gray-900 dark:inset-ring-white/10">
                                    <div class="mx-auto max-w-xs px-8">
                                        <p class="text-base font-semibold text-gray-600 dark:text-gray-400">Add the
                                            Bolt-On</p>
                                        <p class="mt-6 flex items-baseline justify-center gap-x-2">
                                            <span
                                                class="text-5xl font-semibold text-gray-900 dark:text-white">£999</span>
                                            <span
                                                class="text-sm/6 font-semibold tracking-wide text-gray-600 dark:text-gray-400">GBP</span>
                                            <span
                                                class="text-sm/6 font-normal tracking-wide text-gray-600 dark:text-gray-400">/month</span>
                                        </p>
                                        <a
                                            class="mt-10 block w-full rounded-md bg-primary px-3 py-2 text-center text-sm font-semibold text-white shadow-xs hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:shadow-none dark:hover:bg-primary/90 dark:focus-visible:outline-primary">Upgrade
                                            now</a>
                                        <p class="mt-6 text-xs/5 text-gray-600 dark:text-gray-400">Invoices and receipts
                                            available for easy company reimbursement</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <!--NOT Has Rakuten Bolt On - END -->
        </div>

        <div class="mt-6 flex items-center justify-end gap-x-6 w-full">
            <button type="button" (click)="saveRakutenChanges()" class="primary-button">Save</button>
        </div>
    </form>


</div>